import APIClient from './index';
import _ from 'lodash';

export const getLookbookOrdersRequiringAction = () => {
  return new Promise((resolve, reject) => {
    APIClient.get(`/LookbookOrders/orders_requiring_action?cache_buster=${Date.now()}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const updateLookbookOrder = (LookbookOrder_id, updates) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`/LookbookOrders/${LookbookOrder_id}`, updates)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
